var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8UserLocation50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E88E5",
    d: "M7,8v26c0,2.2,1.8,4,4,4h8l5,6l5-6h8c2.2,0,4-1.8,4-4V8c0-2.2-1.8-4-4-4H11C8.8,4,7,5.8,7,8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC80",
    d: "M29,16c0,2.762-2.238,5-5,5s-5-2.238-5-5s2.238-5,5-5S29,13.238,29,16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M33,28c0,0-2-5-9-5s-9,5-9,5v2h18V28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8UserLocation50);
export default __webpack_public_path__ + "static/media/icons8-user-location-50.8c9f9b2d8eddc994c3bd070cf5dd470a.svg";
export { ForwardRef as ReactComponent };